import { trackInfraPageWeightView } from "@faire/web-api--source/events/infra/view/pageWeight";

import { getPageWeightInfo } from "./resourceTiming";
import { ResourceTimingCollector } from "./ResourceTimingCollector";
import { truncatePath } from "./truncatePath";
import { LoadTimingType, ActionName } from "./userPerceivedLoadTiming/types";

const PAGE_NAMES_TO_TRACK: Array<ActionName> = [
  "page-discover-logged-out",
  "page-discover-logged-out-perf",
];
const SAMPLE_RATE = 0.05;

export const trackPageWeight = (
  path: string,
  pageName: ActionName,
  loadType: LoadTimingType,
  timeOfLastRouteChange: number
) => {
  if (loadType !== "DIRECT_LOAD") {
    return;
  }
  if (!PAGE_NAMES_TO_TRACK.includes(pageName)) {
    return;
  }
  if (Math.random() > SAMPLE_RATE) {
    return;
  }

  const entries = ResourceTimingCollector.get().getResourceEntries(
    timeOfLastRouteChange
  );
  if (entries === undefined) {
    return;
  }
  const info = getPageWeightInfo(entries);

  trackInfraPageWeightView(
    JSON.stringify({ path: truncatePath(path), pageName, loadType }),
    JSON.stringify(info)
  );
};
